import script from "./UsersSelectionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersSelectionDialog.vue?vue&type=script&setup=true&lang=js"

import "./UsersSelectionDialog.vue?vue&type=style&index=0&id=14c4591a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14c4591a"]])

export default __exports__